import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { filterChange, sortChange } from "../../features/filter/filterSlice";

export default function Sidebar() {
  const dispatch = useDispatch();
  const [sortOption, setSortOption] = useState("");
  const [filterOption, setFilterOption] = useState("all");

  const handleSort = (e) => {
    const value = e.target.value;
    setSortOption(value);
    dispatch(sortChange(value));
  };
  const handleFilter = (e) => {
    const value = e.target.value;
    setFilterOption(value);
    dispatch(filterChange(value));
  };

  return (
    <aside>
      <div className="sidebar-items">
        <div className="sidebar-content">
          <h4>Sort</h4>
          <select
            name="sort"
            id="lws-sort"
            value={sortOption}
            onChange={handleSort}
            className="w-full max-w-[150px] border-2 rounded-md text-gray-500"
          >
            <option value="">Default</option>
            <option value="newest">Newest</option>
            <option value="most_liked">Most Liked</option>
          </select>
        </div>
        <div className="sidebar-content">
          <h4>Filter</h4>
          <div className="radio-group">
            {/* <!-- handle filter on button click --> */}
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-all"
                value="all"
                checked={filterOption === "all"}
                className="radio"
                onChange={handleFilter}
              />
              <label htmlFor="lws-all">All</label>
            </div>
            <div>
              <input
                type="radio"
                name="filter"
                id="lws-saved"
                className="radio"
                value="saved"
                checked={filterOption === "saved"}
                onChange={handleFilter}
              />
              <label htmlFor="lws-saved">Saved</label>
            </div>
          </div>
        </div>
      </div>
    </aside>
  );
}
